












import { Vue, Component, Prop } from 'vue-property-decorator';
import { IDocumentPage } from '@/types/document-page';
import VideoLoaderPage from '@/dealroom/video/components/VideoLoaderPage.vue';
import VideoPlayer from '@/video/player/components/VideoPlayer.vue';

import { IOptionMenuItem } from '@/dealroom/types/option-menu-item';
import { EOptionMenuItemCallback } from '@/dealroom/types/enums/option-menu-item-callback';

@Component({
  components: {
    VideoLoaderPage,
    VideoPlayer,
  },
})
export default class VideoPage extends Vue {
  @Prop() page!: IDocumentPage;

  currentVideoPlayTime: number = null;
  showOptions: boolean = false;

  get options(): IOptionMenuItem[] {
    return [
      {
        icon: 'edit',
        title: this.$t('edit').toString(),
        callback: EOptionMenuItemCallback.Edit,
      },
      {
        icon: 'move',
        title: this.$t('move').toString(),
        callback: EOptionMenuItemCallback.Move,
      },
      {
        icon: 'delete',
        title: this.$t('delete').toString(),
        callback: EOptionMenuItemCallback.Delete,
      },
    ];
  }

  handleTimeUpdate(playtime: number): void {
    this.currentVideoPlayTime = playtime;
  }

  handlePause(): void {
    this.sendTrackingData();
  }

  handleEnded(): void {
    this.sendTrackingData();
  }

  handleShowOptions() {
    this.showOptions = true;
  }

  hideOptions() {
    this.showOptions = false;
  }

  sendTrackingData(): void {
    if (!this.currentVideoPlayTime) {
      return;
    }
    this.$emit('trackVideo', { id: this.page.video.id, viewDuration: this.currentVideoPlayTime });
    this.currentVideoPlayTime = null;
  }
}
